// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"61":"392ddc49","315":"1888f782","835":"0002e71a"}[chunkId] + ".css";
};